class PbController {
    async __req(path, opts = {}) {
        let body = await fetch(path, {
            credentials: 'include',
            ...opts
        })

        if (body.status !== 200) {
            throw new Error('unauthorized')
        }

        return await body.json()
    }

    async download_profile() {
        let prof = await fetch('/api/profile', {
            credentials: 'include'
        })

        this.prof = await prof.json()
        return this.prof
    }

    /* --- FILE UPLOAD --- */

    async paste_list() {
        const list = await this.__req('/api/pastes/user')
        return list
    }

    async paste_get(paste_id) {
        return await this.__req(`/api/pastes/view/${paste_id}`)
    }

    async paste_delete(paste_id) {
        return await this.__req(`/api/pastes/view/${paste_id}`, {
            method: 'DELETE'
        })
    }

    async paste_create(title, description, body, file_type) {
        const payload = {
            title,
            description,
            body,
            file_type
        }

        let req = fetch('/api/pastes/create', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })

        req = await req

        const resp = await req.json()

        if (!resp.ok) {
            return null
        }

        return resp.paste_id
    }

}

export default PbController
